import React, { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SessionPage from './pages/SessionPage';
import ReportsPage from './pages/ReportsPage';
import UsersPage from './pages/UsersPage';
import HotelsPage from './pages/HotelsPage';
import { api } from './api';
import './app.css';

const NAV = [
  { id: 'dashboard', label: 'Дашборд',      icon: '🏠' },
  { id: 'reports',   label: 'Отчёты',        icon: '📊' },
  { id: 'hotels',    label: 'Отели',          icon: '🏨', admin: true },
  { id: 'users',     label: 'Пользователи',   icon: '👤', admin: true },
];

export default function App() {
  const [user, setUser]         = useState(null);
  const [page, setPage]         = useState('dashboard');
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const t = localStorage.getItem('meal_token');
    if (t) { api.me().then(u => { setUser(u); setLoading(false); }).catch(() => setLoading(false)); }
    else { setLoading(false); }
  }, []);

  const logout = () => { localStorage.removeItem('meal_token'); setUser(null); setPage('dashboard'); };
  const openSession = (id) => { setSessionId(id); setPage('session'); };
  const goBack = () => { setSessionId(null); setPage('dashboard'); };

  if (loading) return <div className="loader"><span>🍽</span> Загрузка...</div>;
  if (!user) return <LoginPage onLogin={u => setUser(u)} />;

  const initials = user.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  const roleLabel = { superadmin: 'Суперадмин', admin: 'Администратор', manager: 'Управляющий' };

  return (
    <div className="app">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="sidebar-brand-icon">🍽</div>
          <div className="sidebar-brand-name">Питание</div>
          <div className="sidebar-brand-sub">для отелей</div>
        </div>
        <nav className="sidebar-nav">
          {NAV.filter(n => !n.admin || user.role === 'superadmin').map(n => (
            <button key={n.id}
              className={page === n.id || (page === 'session' && n.id === 'dashboard') ? 'active' : ''}
              onClick={() => { if (n.id !== page) { setSessionId(null); setPage(n.id); } }}>
              <span className="nav-icon">{n.icon}</span>
              {n.label}
            </button>
          ))}
        </nav>
        <div className="sidebar-user">
          <div className="sidebar-avatar">{initials}</div>
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">{user.name}</div>
            <div className="sidebar-user-role">{roleLabel[user.role] || user.role}</div>
          </div>
          <button className="sidebar-logout" onClick={logout} title="Выйти">↪</button>
        </div>
      </aside>

      {/* Content */}
      <div className="content">
        {page === 'dashboard' && !sessionId && <DashboardPage user={user} onOpenSession={openSession} />}
        {page === 'session'   && sessionId   && <SessionPage user={user} sessionId={sessionId} onBack={goBack} />}
        {page === 'dashboard' && sessionId   && <SessionPage user={user} sessionId={sessionId} onBack={goBack} />}
        {page === 'reports'   && <ReportsPage user={user} />}
        {page === 'hotels'    && user.role === 'superadmin' && <HotelsPage />}
        {page === 'users'     && user.role === 'superadmin' && <UsersPage />}
      </div>
    </div>
  );
}
